<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_2">Dedication</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2">This book is dedicated to my father, Anthony R. Mascia, MD, who supervised a medical clinic for the Allies in Cherbourg, France, soon after the D Day invasion in the summer of 1944—as well as two other infirmaries in Deauville, France and Brussels, Belgium. My father taught me about the inestimable value of each human life. He frequently lamented that wars not only cause immense tragedy and human suffering, but they impoverish our world of countless talents and gifts due to the loss of many millions of lives, cut short in the prime of youth.</p>
<p class="block_4"> </p>
<p class="block_2">I also dedicate this book to a beloved theologian, whose many reflections on how beauty opens the soul to God inspired me to create this work.</p>
<p class="block_4"> </p>
<p class="block_5">To those of us who live in comfort, security, and peace, may this story be a reminder of the millions of innocent civilians of the twentieth century and our current century, who, through no fault of their own, were brutally forced to leave behind their homes and livelihoods forever, journeying towards a future of profound hardship, uncertainty, and poverty.</p>
<p class="block_6"> </p>
<p class="block_7" id="calibre_pb_1"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?6f5469fb